import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmployeeSettingsPage from "@/pages/employee/EmployeeSettingsPage";

export const Route = createFileRoute("/employee/settings")({
  head: () => pageHead("Employee · Settings", "AKIVA employee · account settings.", "/employee/settings", true),
  component: EmployeeSettingsPage,
});
